<template>
  <v-dialog v-model="dialog" max-width="75%">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark v-on="on" v-if="!isEdit">
        <v-icon left>fas fa-cube</v-icon>
        New Line Item
      </v-btn>
      <v-btn v-else icon color="primary" v-on="on">
        <v-icon>edit</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Shipping Line Item Form</v-card-title>
      <v-card-text>
        <v-form v-model="$v.valid" @submit.prevent="submit">
          <v-autocomplete
            label="Batch"
            allow-overflow
            :items="batches"
            :item-text="item => item.forgeID + ' - ' + item.name"
            item-value="id"
            :error-messages="batchErrors"
            :prepend-icon="formdata.batchIcon"
            :loading="loadingBatches"
            v-model="$v.formdata.batch_id.$model"
            @input="$v.formdata.batch_id.$touch()"
            @blur="$v.formdata.batch_id.$touch()"
          >
          </v-autocomplete>
          <v-text-field
            label="Quantity"
            placeholder="10 kgs"
            :error-messages="quantityErrors"
            counter="24"
            v-model="$v.formdata.quantity.$model"
            :prepend-icon="formdata.quantityIcon"
            @input="$v.formdata.quantity.$touch()"
            @blur="$v.formdata.quantity.$touch()"
          />
          <v-text-field
            label="Notes"
            placeholder="Specify a Run"
            counter="128"
            :error-messages="notesErrors"
            v-model="$v.formdata.notes.$model"
            :prepend-icon="formdata.notesIcon"
            @input="$v.formdata.notes.$touch()"
            @blur="$v.formdata.notes.$touch()"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" dark @click="dialog = false">
          <v-icon left>mdi-close</v-icon>
          Close
        </v-btn>
        &nbsp;
        <v-btn color="warning" dark @click="clear">
          <v-icon left>fas fa-redo</v-icon>
          Clear
        </v-btn>
        &nbsp;
        <v-btn :disabled="$v.$invalid" color="primary" @click="submit">
          <v-icon dark left>
            fas fa-save
          </v-icon>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ShippingItem } from "../../models/Shipping";
import { validationMixin } from "vuelidate";
import { handleErrors } from "../../services/formErrors";
export default {
  name: "ShippingItemForm",
  mixins: [validationMixin],
  validations: ShippingItem.validations,
  props: {
    ticketid: {
      type: Number,
      required: true
    },
    isEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    instance: {
      type: Object,
      default: () => {}
    },
    batches: {
      type: Array,
      required: true,
      default: () => []
    },
    loadingBatches: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data() {
    return {
      dialog: false,
      formdata: new ShippingItem(this.instance)
    };
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.isEdit) {
        ShippingItem
          .$put(this.instance.id, this.formdata.toUpdatePayload())
          .then(() => this.dialog = false)
      } else {
        this.formdata.ticket_id = this.ticketid;
        ShippingItem
          .$post(this.formdata.toCreatePayload())
          .then(() => this.clear())
      }
    },
    clear() {
      this.formdata = new ShippingItem();
      this.$v.$reset();
      this.dialog = false;
    }
  },
  computed: {
    batchErrors() {
      return handleErrors("formdata", "batch_id", this);
    },
    quantityErrors() {
      return handleErrors("formdata", "quantity", this);
    },
    notesErrors() {
      return handleErrors("formdata", "notes", this);
    }
  }
};
</script>
